(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  (() => {
    const el = document.querySelector('.shopify-section--announcement-bar');
    if (!el) return;
    const set = () => document.documentElement.style.setProperty('--announcement-bar-height', `${Math.round(el.clientHeight)}px`);
    set();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  const spechtFooterBreakpoint = window.matchMedia('(min-width: 750px)');
  function syncSpechtFooterMenus() {
    document.querySelectorAll('.specht-footer__nav').forEach((menu) => {
      menu.open = spechtFooterBreakpoint.matches;
    });
  }
  syncSpechtFooterMenus();
  spechtFooterBreakpoint.addEventListener('change', syncSpechtFooterMenus);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const el = document.querySelector('.shopify-section--header');
    if (!el) return;
    const set = () => document.documentElement.style.setProperty('--header-height', `${Math.round(el.clientHeight)}px`);
    set();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium_carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-thc-carousel]').forEach((carouselEl) => {
    const root = carouselEl.closest('.shopify-section');
    if (!root || root.dataset.premiumCarouselReady === 'true') return;
    root.dataset.premiumCarouselReady = 'true';

    const defaultColumns = carouselEl.dataset.defaultColumns || '4';
    const tabs = [...root.querySelectorAll('.thc-nav-btn')];
    const panels = [...root.querySelectorAll('.thc-products-container')];
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const boundGrids = new WeakSet();

    const syncPanelLayout = (panel) => {
      const grid = panel.querySelector('.thc-products');
      const dots = panel.querySelector('.thc-dots');
      if (!grid) return;
      const count = grid.querySelectorAll('.thc-item').length;
      const columns = Number.parseInt(grid.dataset.columns, 10) || Number.parseInt(defaultColumns, 10) || 4;
      if (dots) {
        dots.style.setProperty('--thc-dots-mobile-height', count > 2 ? '28px' : '0px');
        dots.style.setProperty('--thc-dots-desktop-height', count > columns ? '28px' : '0px');
      }
      grid.querySelectorAll('.product-card__image').forEach((image) => {
        if (carouselEl.dataset.imageSizes && image.sizes !== carouselEl.dataset.imageSizes) image.sizes = carouselEl.dataset.imageSizes;
      });
    };

    const getLayout = (grid) => {
      const items = [...grid.querySelectorAll('.thc-item')];
      const columns = Number.parseInt(grid.dataset.columns, 10) || Number.parseInt(defaultColumns, 10) || 4;
      const mobile = window.matchMedia('(max-width: 989px)').matches;
      return { items, itemsPerPage: mobile ? 2 : columns, mobile };
    };

    const updateActiveDot = (panel) => {
      const grid = panel.querySelector('.thc-products');
      const dots = [...panel.querySelectorAll('.thc-dot')];
      if (!grid || dots.length === 0) return;
      const { items, itemsPerPage } = getLayout(grid);
      if (items.length === 0) return;
      const targetIndex = items.reduce((best, item, index) => {
        const distance = Math.abs(item.offsetLeft - grid.scrollLeft);
        return distance < best.distance ? { index, distance } : best;
      }, { index: 0, distance: Number.POSITIVE_INFINITY }).index;
      const currentPage = Math.min(dots.length - 1, Math.floor(targetIndex / itemsPerPage));
      dots.forEach((dot, index) => {
        const active = index === currentPage;
        dot.classList.toggle('active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    };

    const bindGridScroll = (panel) => {
      const grid = panel.querySelector('.thc-products');
      if (!grid || boundGrids.has(grid)) return;
      boundGrids.add(grid);
      let frame = 0;
      grid.addEventListener('scroll', () => {
        if (frame) return;
        frame = requestAnimationFrame(() => {
          frame = 0;
          updateActiveDot(panel);
        });
      }, { passive: true });
    };

    const renderDots = (panel) => {
      syncPanelLayout(panel);
      const grid = panel.querySelector('.thc-products');
      const dotsWrap = panel.querySelector('.thc-dots');
      if (!grid || !dotsWrap) return;
      const { items, itemsPerPage, mobile } = getLayout(grid);
      const totalPages = Math.ceil(items.length / itemsPerPage);
      dotsWrap.replaceChildren();
      if (totalPages <= 1) return;
      for (let page = 0; page < totalPages; page += 1) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = `thc-dot${page === 0 ? ' active' : ''}`;
        dot.setAttribute('aria-label', `Ir para página ${page + 1} de ${totalPages}`);
        dot.setAttribute('aria-current', page === 0 ? 'true' : 'false');
        dot.addEventListener('click', () => {
          const target = items[page * itemsPerPage];
          if (!target) return;
          grid.scrollTo({ left: target.offsetLeft - (mobile ? 20 : 0), behavior: reducedMotion.matches ? 'auto' : 'smooth' });
        });
        dotsWrap.appendChild(dot);
      }
      bindGridScroll(panel);
      updateActiveDot(panel);
    };

    const panelLoads = new WeakMap();
    const hydratePanel = async (panel) => {
      if (!panel || panel.dataset.thcDeferred !== 'true') return;
      if (panelLoads.has(panel)) return panelLoads.get(panel);
      const feedback = panel.querySelector('[data-thc-feedback]');
      const status = feedback.querySelector('[role="status"]');
      const collectionLink = feedback.querySelector('a');
      status.textContent = status.dataset.loading;
      const loading = (async () => {
        try {
          if (!collectionLink) throw new Error('collection unavailable');
          const url = new URL(collectionLink.href);
          url.searchParams.set('sections', 'thc-products-panel');
          const response = await fetch(url, { credentials: 'same-origin' });
          if (!response.ok) throw new Error('section request failed');
          const payload = await response.json();
          const html = payload['thc-products-panel'];
          if (!html) throw new Error('section empty');
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const products = doc.querySelector('.thc-products');
          const dots = panel.querySelector(':scope > .thc-dots');
          if (!products) throw new Error('product grid unavailable');
          products.setAttribute('data-columns', panel.dataset.columns || defaultColumns);
          products.querySelectorAll('form[is="product-form"]').forEach((form) => {
            form.setAttribute('id', `${panel.id}-${form.getAttribute('id')}`);
          });
          panel.insertBefore(products, dots || null);
          syncPanelLayout(panel);
          feedback.hidden = true;
          delete panel.dataset.thcDeferred;
        } catch {
          status.textContent = status.dataset.error;
        }
      })();
      panelLoads.set(panel, loading);
      try {
        return await loading;
      } finally {
        panelLoads.delete(panel);
      }
    };

    let selectionVersion = 0;
    const activate = async (index) => {
      const version = ++selectionVersion;
      tabs.forEach((tab) => {
        const active = tab.dataset.index === index;
        tab.classList.toggle('active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
      });
      const selectedPanel = panels.find((panel) => panel.dataset.index === index);
      for (const panel of panels) {
        const active = panel.dataset.index === index;
        panel.hidden = !active;
      }
      if (!selectedPanel) return;
      await hydratePanel(selectedPanel);
      if (version !== selectionVersion) return;
      requestAnimationFrame(() => {
        if (version === selectionVersion) renderDots(selectedPanel);
      });
    };

    tabs.forEach((tab, index) => {
      tab.tabIndex = tab.getAttribute('aria-selected') === 'true' ? 0 : -1;
      tab.addEventListener('focus', () => {
        tabs.forEach((item) => { item.tabIndex = item === tab ? 0 : -1; });
      });
      tab.addEventListener('click', (event) => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        activate(tab.dataset.index);
      });
      tab.addEventListener('keydown', (event) => {
        if (event.key === ' ') {
          event.preventDefault();
          activate(tab.dataset.index);
          return;
        }
        const destinations = {
          ArrowLeft: (index - 1 + tabs.length) % tabs.length,
          ArrowRight: (index + 1) % tabs.length,
          Home: 0,
          End: tabs.length - 1
        };
        if (!Object.hasOwn(destinations, event.key)) return;
        event.preventDefault();
        tabs[destinations[event.key]].focus();
      });
    });
    const tabList = root.querySelector('[role="tablist"]');
    tabList?.addEventListener('focusout', (event) => {
      if (!tabList.contains(event.relatedTarget)) {
        tabs.forEach((tab) => { tab.tabIndex = tab.getAttribute('aria-selected') === 'true' ? 0 : -1; });
      }
    });

    const initialPanel = panels.find((panel) => !panel.hidden) || panels[0];
    if (initialPanel) renderDots(initialPanel);

    let resizeFrame = 0;
    window.addEventListener('resize', () => {
      if (resizeFrame) return;
      resizeFrame = requestAnimationFrame(() => {
        resizeFrame = 0;
        const activePanel = panels.find((panel) => !panel.hidden) || panels[0];
        if (activePanel) renderDots(activePanel);
      });
    }, { passive: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.shopify-section--video').forEach((sectionRoot) => {
    const playButton = sectionRoot.querySelector('.video-play-button');
    const videoMedia = sectionRoot.querySelector('video-media');
    if (!playButton || !videoMedia) return;
    videoMedia.addEventListener('media:play', () => {
      playButton.hidden = true;
      playButton.setAttribute('aria-hidden', 'true');
    });
    playButton.addEventListener('click', async (event) => {
      event.preventDefault();
      await customElements.whenDefined('video-media');
      videoMedia.play();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
